const DeliveryMethod = {
    Cup: 'CUP',
    Courier: 'COURIER',
    Dealership: 'DEALERSHIP',
}

export {
    DeliveryMethod,
}